import { FunctionComponent } from "react";
import { Button, Modal } from "antd";
import { EuroCircleOutlined } from "@ant-design/icons";
import { SituationPaiement } from "../../services/paiement";
import { PaiementsInscription } from "./PaiementsInscription";

export type ModalPaiementsProps = {
    open: boolean;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
    idInscription?: number;
    /** Notifie l'appelant pour qu'il rafraîchisse la ligne correspondante de sa liste. */
    onChange?: (situation: SituationPaiement) => void;
};

/**
 * Ouverte depuis la liste d'administration, où l'on ne dispose que de l'identifiant de
 * l'inscription : le bloc charge donc lui-même sa situation.
 */
export const ModalPaiements: FunctionComponent<ModalPaiementsProps> = ({ open, setOpen, idInscription, onChange }) => {

    const close = () => setOpen(false);

    return (
        <Modal
            title={<span><EuroCircleOutlined /> Paiements de l'inscription</span>}
            open={open}
            width={900}
            onCancel={close}
            destroyOnClose
            footer={<Button onClick={close} type="primary" {...({ testid: "fermer-modale-paiements" } as any)}>Fermer</Button>}
        >
            {idInscription && <PaiementsInscription idInscription={idInscription} onChange={onChange} />}
        </Modal>
    );
};
